module.exports = __webpack_public_path__ + "static/media/as1cr44.af7e3568.png";